import { useParams, Navigate, Link } from "react-router-dom";
import { Check, ArrowRight, MessageCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { SERVICES, IMAGES, WHATSAPP_URL, FAQS } from "../lib/site-data";
import LeadForm from "../components/sections/LeadForm";
import FAQ from "../components/sections/FAQ";
import Process from "../components/sections/Process";
import FinalCTA from "../components/sections/FinalCTA";
import useSEO from "../lib/useSEO";

export default function ServiceDetail({ slug: slugProp }) {
    const params = useParams();
    const slug = slugProp || params.slug;
    const service = SERVICES.find((s) => s.slug === slug);

    useSEO({
        title: service
            ? `${service.title} | İstanbul Dövme Silme - Doğuş Çizikoğlu`
            : "Hizmet bulunamadı",
        description: service ? service.intro : "",
        canonical: `https://www.istanbuldovmesilme.com/${slug}`,
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "MedicalProcedure",
            name: service?.title,
            description: service?.intro,
        },
    });

    if (!service) return <Navigate to="/" replace />;
    const heroImg = IMAGES[service.image] || IMAGES.treatment1;

    return (
        <>
            <section className="relative overflow-hidden border-b border-white/5">
                <div className="absolute inset-0">
                    <img src={heroImg} alt="" className="w-full h-full object-cover opacity-30" />
                    <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black"></div>
                </div>
                <div className="relative max-w-[1200px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-xs text-zinc-400 hover:text-cyan-300 mb-6"
                    >
                        ← Anasayfa
                    </Link>
                    <p className="text-xs uppercase tracking-[0.3em] text-cyan-300/80 mb-4">
                        {service.keywords}
                    </p>
                    <h1 className="font-display text-4xl md:text-6xl text-white tracking-tight max-w-3xl text-balance">
                        {service.title}
                    </h1>
                    <p className="text-base md:text-lg text-zinc-400 mt-6 max-w-2xl leading-relaxed">
                        {service.intro}
                    </p>

                    <ul className="mt-8 space-y-3 max-w-2xl">
                        {service.bullets.map((b) => (
                            <li key={b} className="flex items-start gap-3 text-zinc-300">
                                <Check className="h-4 w-4 text-cyan-300 mt-1 flex-shrink-0" />
                                <span className="text-sm leading-relaxed">{b}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="flex flex-col sm:flex-row gap-3 mt-8">
                        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                            <Button className="bg-cyan-400 text-black hover:bg-cyan-300 font-medium px-7 py-6">
                                <MessageCircle className="h-5 w-5 mr-2" />
                                WhatsApp'tan Fotoğraf Gönder
                            </Button>
                        </a>
                        <a href="#lead-form">
                            <Button
                                variant="outline"
                                className="bg-transparent border-white/20 text-white hover:bg-white/5 px-7 py-6"
                            >
                                Ön Değerlendirme Formu
                                <ArrowRight className="h-4 w-4 ml-2" />
                            </Button>
                        </a>
                    </div>

                    <p className="text-xs text-zinc-500 mt-8 max-w-2xl leading-relaxed">
                        Sonuçlar kişiden kişiye değişebilir. Net seans sayısı ve uygunluk, cilt yapısı
                        ve dövme/iz analizi sonrası belirlenir.
                    </p>
                </div>
            </section>

            <Process />
            <LeadForm defaultService={service.title} />
            <FAQ items={FAQS} />
            <FinalCTA />
        </>
    );
}
